module.exports = __webpack_public_path__ + "img/failed.038904cd.png";